import { memo, useEffect, useReducer } from "react"
import { StateProp } from "../types"
import UserContext from "./context"
import { initial_user, userReducer } from "./reducer"
import { setUser, setUserInitialization, updateTokens } from "./actions"
import { updateUser } from "../../services/calls/users"
import { changeLanguage } from "../../services/utils/language"
import { getAvailableFleets } from "../../services/calls/fleet"

const UserState = memo(({ children }: StateProp) => {
  const [user, dispatch] = useReducer(userReducer, initial_user)

  const fetchUser = async () => {
    const fetchedUser = await updateUser()
    if (typeof fetchedUser === 'object') {
      const fleets = await getAvailableFleets()
      const newUser = {
        ...fetchedUser,
        available_fleets: fleets,
        name: `${fetchedUser.first_name} ${fetchedUser.last_name}`
      }
      dispatch(setUser(newUser))
      
      const { language } = newUser
      changeLanguage(language === 'en-gb' ? 'en' : 'is')
    }
    dispatch(setUserInitialization(true))
  }

  useEffect(() => {
    const initialize = async () => {
      const oldAccessToken = await localStorage.getItem('access_token')
      const oldRefreshToken = await localStorage.getItem('refresh_token')

      if ((oldAccessToken && oldAccessToken !== 'undefined') || (oldRefreshToken && oldRefreshToken !== 'undefined')) {
        await dispatch(updateTokens({ access: oldAccessToken, refresh: oldRefreshToken }))
        await fetchUser()
      }
    }

    initialize()
    dispatch(setUserInitialization(true))
  }, [])

  useEffect(() => {
    if (user.initialized) {
      localStorage.setItem('access_token', user.access_token)
      localStorage.setItem('refresh_token', user.refresh_token)
      
      if (!user.username.length && user.access_token) {
        fetchUser()
      }
    }
  }, [user.access_token, user.refresh_token])

  return (
    <UserContext.Provider value={{ user, dispatch }}>
      {children}
    </UserContext.Provider>
  )
})

export default UserState
